// extracted by mini-css-extract-plugin
export default {"body2paso":"ConectarMp_body2paso__KSwCK","eventos":"ConectarMp_eventos__2fnG+","botonConectarMp":"ConectarMp_botonConectarMp__8xp3w"};